import { Injectable } from '@angular/core';
import { HttpEvent, HttpEventType, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { BaseService } from './base.service';
import { environment } from '../../../environments/environment';

export interface UploadProgress {
  progress: number;
  state: 'PENDING' | 'IN_PROGRESS' | 'DONE';
  response?: any;
}

@Injectable({
  providedIn: 'root'
})
export class FileUploaderService extends BaseService {
  private readonly filesUrl = environment.apiUrl;
  uploadFile(filePath: string, files: File[] | File, extraData: Record<string, string> = {},fileName?: string): Observable<UploadProgress> {
    const formData = new FormData();
    const fileArray = Array.isArray(files) ? files : [files];
    fileArray.forEach(file => {
      formData.append('file', file);
      formData.append('fileName', fileName || file.name);
    });

    formData.append('filePath', filePath);
    Object.keys(extraData).forEach(key => {
      formData.append(key, extraData[key]);
    });

    return this.trackUpload(`/gafi-cpcr/storage-minio/upload`, formData);
  }
  uploadSignedFile( basePath: string ,signedFile: File ,fileName: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', signedFile, fileName);
    formData.append('basePath', basePath);
    formData.append('fileName', fileName);
    const url = `${this.filesUrl}/gafi-cpcr/pdf/upload`;
    return this.http.post(url, formData, { headers: { Accept: '*/*' } });
  }

  private trackUpload(endpoint: string, formData: FormData): Observable<UploadProgress> {
    return this.http.post(`${this.filesUrl}${endpoint}`, formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = event.total ? Math.round((100 * event.loaded) / event.total) : 0;
            return { progress: progress, state: 'IN_PROGRESS' } as UploadProgress;

          case HttpEventType.Response:
            return { progress: 100, state: 'DONE', response: event.body } as UploadProgress;

          default:
            return { progress: 0, state: 'PENDING' } as UploadProgress;
        }
      })
    );
  }
  deleteFile(filePath: string): Observable<any> {
    return this.http.delete(`${this.filesUrl}/gafi-cpcr/storage-minio/delete`, {
      params: { filePath }
    });
  }

  getFileData(filePath: string): Observable<any> {
    const params = new HttpParams().set('filePath', filePath);
    return this.http.get(`${this.filesUrl}/gafi-cpcr/storage-minio/file-data`, { params });
  }
}
